<template>
	<div class="progress-input-storage">
		<progress-input-auto-increment
			v-for="(item, index) in storagesName"
			:key="index"
			:index="index"
			:length="storagesName.length"
			:placeholder="placeholder"
			v-model="storagesName[index]"
			@update="updateStorage"
			@clickDelete="clickDeleteStorage"
		>
		</progress-input-auto-increment>
	</div>
</template>

<script>
import ProgressInputAutoIncrement from '@/views/create/components/ProgressInputAutoIncrement.vue'
export default {
	name: 'ProgressInputStorage',
	components: {
		ProgressInputAutoIncrement,
	},
	props: {
		storagesName: {
			type: Array,
			default: () => [],
		},
		placeholder: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			inputStorageValue: '',
		}
	},
	methods: {
		updateStorage(index, storage) {
			this.$emit('updateStorage', index, storage)
		},
		clickDeleteStorage(index) {
			this.$emit('clickDeleteStorage', index)
		},
	},
}
</script>

<style lang="scss" scoped>
.progress-input-storage {
	width: 100%;
	.storage-item {
		width: 100%;
		border: 1px solid #ddd;
		border-radius: 8px;
		padding: 8px 14px;
		position: relative;
		margin-bottom: 10px;
		span {
			font-size: 0.75rem;
			font-weight: 400;
			display: block;
			color: #999;
		}
		h1 {
			font-size: 1rem;
			font-weight: 400;
			margin-top: 2px;
		}
		button {
			position: absolute;
			top: 50%;
			right: 14px;
			padding: 0 0;
			transform: translateY(-50%);
		}
	}
	.progress-input {
		position: relative;
		input {
			width: 100%;
			height: 56px;
			border-radius: 8px;
			border: 1px solid #ddd;
			padding: 10px 14px 0 14px;
			font-size: 1rem;
		}
		input:focus {
			border-color: #000;
		}
		input:focus ~ .placeholder {
			font-size: 0.75rem;
			top: 5px;
		}
		.placeholder {
			position: absolute;
			font-size: 1rem;
			font-weight: 400;
			color: #999;
			display: block;
			top: 16px;
			left: 14px;
			transition: all 0.3s;
			background-color: unset !important;
			&.active {
				font-size: 0.75rem;
				top: 5px;
			}
		}
	}
}
</style>
